import React from "react";
import ReactDOM from "react-dom";
import PropTypes from "prop-types";

import FTSocket from "./SocketController";
import MessageHeader from "./MessageHeader";
import MessageList from "./MessageList";

export default function MessageHolder({ domNode, socketInstance }){
	return (
		ReactDOM.createPortal(
			<div className="socket-messages">
				<MessageHeader socketInstance={socketInstance} />
				<MessageList socketInstance={socketInstance} />
			</div>
			, document.getElementById(domNode)
		)
	);
}

MessageHolder.displayName = "MessageHolder";
MessageHeader.propTypes = {
	socketInstance:PropTypes.instanceOf(FTSocket).isRequired,
};
